// Utility to format a date string as fuzzy time (e.g., '3 minutes ago', 'yesterday')
// Uses the current local time as provided by the system.

const NOW = new Date('2025-06-08T22:31:02+12:00'); // Source of truth for 'now'

export function formatFuzzyTime(dateString: string): string {
  const date = new Date(dateString);
  const now = NOW;
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin === 1) return 'a minute ago';
  if (diffMin < 60) return `${diffMin} minutes ago`;
  if (diffHr === 1) return 'an hour ago';
  if (diffHr < 24) return `${diffHr} hours ago`;
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 7) return `${diffDay} days ago`;
  // Fallback: show date in YYYY-MM-DD
  return date.toISOString().slice(0, 10);
}
